export default __webpack_public_path__ + "static/media/repay.c89b4928.svg";